import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useBatches } from 'features/schools/hooks/useSchools';
import {
  hasAskGuruEnrollmentForPath,
  hasAskGuruEnrollmentForSchool,
  type AskGuruEnrollmentRef,
} from 'shared/lib/askBhriguEnrollmentAccess';
import type { Batch } from 'types';

function toEnrollmentRef(batch: Batch): AskGuruEnrollmentRef {
  return {
    batchId: batch.id,
    schoolSlug: batch.schoolSlug,
    courseId: batch.courseId,
    enrollmentStatus: batch.enrollmentStatus,
    isPastEnrollment: batch.isPastEnrollment,
  };
}

export function useAskGuruEnrollmentAccess(): {
  enrollments: AskGuruEnrollmentRef[];
  hasEnrollmentForPath: boolean;
  hasEnrollmentForSchool: (schoolSlug: string) => boolean;
} {
  const { pathname } = useLocation();
  const { data: batches } = useBatches();

  const enrollments = useMemo(
    () => (batches ?? []).map(toEnrollmentRef),
    [batches]
  );

  const hasEnrollmentForPath = useMemo(
    () => hasAskGuruEnrollmentForPath(pathname, enrollments),
    [pathname, enrollments]
  );

  const hasEnrollmentForSchool = useMemo(
    () => (schoolSlug: string) => hasAskGuruEnrollmentForSchool(schoolSlug, enrollments),
    [enrollments]
  );

  return { enrollments, hasEnrollmentForPath, hasEnrollmentForSchool };
}
